import { render, staticRenderFns } from "./VlogDetail.vue?vue&type=template&id=4a01bec8&scoped=true"
import script from "./VlogDetail.vue?vue&type=script&lang=js"
export * from "./VlogDetail.vue?vue&type=script&lang=js"
import style0 from "./VlogDetail.vue?vue&type=style&index=0&id=4a01bec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a01bec8",
  null
  
)

export default component.exports